import { Range, Transforms } from 'slate';

function replaceRangeWithText(editor, {
  at,
  text
}) {
  if (Range.isExpanded(at)) {
    Transforms.select(editor, at);
    Transforms.delete(editor);
  }
  if (!editor.selection) {
    throw new Error('Editor selection is null after replacing range with text');
  }
  const {
    anchor
  } = editor.selection;
  Transforms.insertText(editor, text);
  return {
    anchor,
    focus: {
      ...anchor,
      offset: anchor.offset + text.length
    }
  };
}

export { replaceRangeWithText };
